import messages_at from './translations/at';
import messages_at_allianzat_solvdui from './translations/at.allianzat.solvdui';
import messages_ca from './translations/ca';
import messages_ca_assegurad from './translations/ca.assegurad';
import messages_cs from './translations/cs';
import messages_cs_allianzcz from './translations/cs.allianzcz';
import messages_cs_allianzcz_solvdui from './translations/cs.allianzcz.solvdui';
import messages_cz_allianzcz_easyclaim from './translations/cz.allianzcz.easyclaim';
import messages_de from './translations/de';
import messages_dev from './translations/dev';
import messages_en from './translations/en';
import messages_en_allianzat from './translations/en.allianzat';
import messages_en_allianzbbva from './translations/en.allianzbbva';
import messages_en_allianzcee_easyclaim from './translations/en.allianzcee.easyclaim';
import messages_en_allianzcee_solvdui from './translations/en.allianzcee.solvdui';
import messages_en_allianzcz from './translations/en.allianzcz';
import messages_en_allianzcz_easyclaim from './translations/en.allianzcz.easyclaim';
import messages_en_allianzdirect from './translations/en.allianzdirect';
import messages_en_allianzes from './translations/en.allianzes';
import messages_en_allianzeu from './translations/en.allianzeu';
import messages_en_allianzhr from './translations/en.allianzhr';
import messages_en_allianzhu from './translations/en.allianzhu';
import messages_en_allianzpt from './translations/en.allianzpt';
import messages_en_allianzsi from './translations/en.allianzsi';
import messages_en_allianzsk from './translations/en.allianzsk';
import messages_en_allianzsk_easyclaim from './translations/en.allianzsk.easyclaim';
import messages_en_assegurad from './translations/en.assegurad';
import messages_en_controlexpert from './translations/en.controlexpert';
import messages_en_link4 from './translations/en.link4';
import messages_en_mapfrees from './translations/en.mapfrees';
import messages_en_solvd from './translations/en.solvd';
import messages_en_tuz from './translations/en.tuz';
import messages_en_uniqapl from './translations/en.uniqapl';
import messages_es from './translations/es';
import messages_es_allianzbbva from './translations/es.allianzbbva';
import messages_es_allianzdirect from './translations/es.allianzdirect';
import messages_es_allianzes from './translations/es.allianzes';
import messages_es_mapfrees from './translations/es.mapfrees';
import messages_hr from './translations/hr';
import messages_hr_allianzhr_easyclaim from './translations/hr.allianzhr.easyclaim';
import messages_hr_allianzhr_solvdui from './translations/hr.allianzhr.solvdui';
import messages_hu from './translations/hu';
import messages_hu_allianzhu_solvdui from './translations/hu.allianzhu.solvdui';
import messages_it from './translations/it';
import messages_jp from './translations/jp';
import messages_pl from './translations/pl';
import messages_pl_compensa from './translations/pl.compensa';
import messages_pl_controlexpert from './translations/pl.controlexpert';
import messages_pl_interrisk from './translations/pl.interrisk';
import messages_pl_link4 from './translations/pl.link4';
import messages_pl_solvd from './translations/pl.solvd';
import messages_pl_trastipl from './translations/pl.trastipl';
import messages_pl_tuz from './translations/pl.tuz';
import messages_pl_unextpl from './translations/pl.unextpl';
import messages_pl_uniqapl from './translations/pl.uniqapl';
import messages_pl_warta from './translations/pl.warta';
import messages_pt from './translations/pt';
import messages_pt_allianzpt_easyclaim from './translations/pt.allianzpt.easyclaim';
import messages_ro from './translations/ro';
import messages_ru from './translations/ru';
import messages_ru_controlexpert from './translations/ru.controlexpert';
import messages_sk from './translations/sk';
import messages_sk_allianzsk from './translations/sk.allianzsk';
import messages_sk_allianzsk_easyclaim from './translations/sk.allianzsk.easyclaim';
import messages_sk_allianzsk_solvdui from './translations/sk.allianzsk.solvdui';
import messages_sl from './translations/sl';
import messages_sl_allianzsi_easyclaim from './translations/sl.allianzsi.easyclaim';
import messages_sl_allianzsi_solvdui from './translations/sl.allianzsi.solvdui';
import messages_th from './translations/th';
import messages_uk from './translations/uk';

const localeMessages = {
	dev: messages_dev,

	de: messages_de,
	pl: messages_pl,
	en: messages_en,
	sk: messages_sk,
	cs: messages_cs,
	jp: messages_jp,
	ca: messages_ca,
	ru: messages_ru,
	th: assignEN(messages_th),
	uk: messages_uk,
	es: messages_es,
	pt: messages_pt,
	sl: messages_sl,
	hr: messages_hr,
	hu: messages_hu,
	it: messages_it,
	at: messages_at,
	ro: messages_ro,
};

const customersLocaleMessages = {
	pl_compensa: assignPL(messages_pl_compensa),
	pl_warta: assignPL(messages_pl_warta),
	pl_link4: assignPL(messages_pl_link4),
	pl_interrisk: assignPL(messages_pl_interrisk),
	pl_controlexpert: assignPL(messages_pl_controlexpert),
	pl_controlexpertcee: assignPL(messages_pl_controlexpert),
	pl_trastipl: assignPL(messages_pl_trastipl),
	pl_unextpl: assignPL(messages_pl_unextpl),
	pl_uniqapl: assignPL(messages_pl_uniqapl),
	pl_pevno: assignPL(messages_pl_uniqapl),
	pl_tuz: assignPL(messages_pl_tuz),
	pl_solvd: assignPL(messages_pl_solvd),

	en_link4: assignEN(messages_en_link4),
	en_allianzeu: assignEN(messages_en_allianzeu),
	en_allianzsk: assignEN(messages_en_allianzsk),
	en_allianzcz: assignEN(messages_en_allianzcz),
	en_allianzat: assignEN(messages_en_allianzat),
	en_allianzsi: assignEN(messages_en_allianzsi),
	en_allianzhr: assignEN(messages_en_allianzhr),
	en_allianzdirect: assignEN(messages_en_allianzdirect),
	en_solvd: assignEN(messages_en_solvd),
	en_controlexpert: assignEN(messages_en_controlexpert),
	en_controlexpertcee: assignEN(messages_en_controlexpert),
	en_controlexpertth: assignEN(messages_en_allianzsk),
	en_assegurad: assignEN(messages_en_assegurad),
	en_allianzpt: assignEN(messages_en_allianzpt),
	en_mapfrees: assignEN(messages_en_mapfrees),
	en_uniqapl: assignEN(messages_en_uniqapl),
	en_allianzbbva: assignEN(messages_en_allianzbbva),
	en_allianzes: assignEN(messages_en_allianzes),
	en_allianzhu: assignEN(messages_en_allianzhu),
	en_pevno: assignEN(messages_en_uniqapl),
	en_tuz: assignEN(messages_en_tuz),

	sk_allianzsk: assignSK(messages_sk_allianzsk),
	cs_allianzcz: assignCS(messages_cs_allianzcz),
	cs_allianzcz_easyclaim: assignCS(messages_cz_allianzcz_easyclaim),
	ca_assegurad: assignCA(messages_ca_assegurad),
	th_controlexpertth: assignEN(messages_th),

	ru_controlexpert: assignRU(messages_ru_controlexpert),
	uk_controlexpert: messages_uk,

	es_mapfrees: assignES(messages_es_mapfrees),
	es_allianzdirect: assignES(messages_es_allianzdirect),
	es_allianzbbva: assignES(messages_es_allianzbbva),
	es_allianzes: assignES(messages_es_allianzes),
};

const customersProcessLocaleMessages = {
	en_allianzat_easyclaim: assignEN(messages_en_allianzcee_easyclaim),
	en_allianzro_easyclaim: assignEN(messages_en_allianzcee_easyclaim),
	en_allianzhr_easyclaim: assignEN(messages_en_allianzcee_easyclaim),
	en_allianzpt_easyclaim: assignEN(messages_en_allianzcee_easyclaim),
	en_allianzsi_easyclaim: assignEN(messages_en_allianzcee_easyclaim),
	en_allianzsk_easyclaim: assignEN(messages_en_allianzsk_easyclaim),
	en_allianzcz_easyclaim: assignEN(messages_en_allianzcz_easyclaim),
	pt_allianzpt_easyclaim: assignPT(messages_pt_allianzpt_easyclaim),
	sk_allianzsk_easyclaim: assignSK(messages_sk_allianzsk_easyclaim),
	sl_allianzsi_easyclaim: assignSL(messages_sl_allianzsi_easyclaim),
	hr_allianzhr_easyclaim: assignHR(messages_hr_allianzhr_easyclaim),
};

const enSolvdUiMessages = assignEN(messages_en_allianzcee_solvdui);
const enSolvdUiMessagesWithoutPolicyNumber = { ...enSolvdUiMessages };

delete enSolvdUiMessagesWithoutPolicyNumber['onboardingStart.damageNumber'];

// Translations selected through the `specialTranslation` field of the case, registered as
// `{locale}_{companyShortName}_{specialTranslation}`.
const customersSpecialLocaleMessages = {
	cs_allianzcz_solvdui: assignCS(messages_cs_allianzcz_solvdui),
	at_allianzat_solvdui: assignAT(messages_at_allianzat_solvdui),
	en_allianzcee_solvdui: enSolvdUiMessagesWithoutPolicyNumber,
	en_allianzat_solvdui: enSolvdUiMessagesWithoutPolicyNumber,
	en_allianzhr_solvdui: enSolvdUiMessagesWithoutPolicyNumber,
	en_allianzhu_solvdui: enSolvdUiMessages,
	en_allianzsk_solvdui: enSolvdUiMessages,
	en_allianzsi_solvdui: enSolvdUiMessagesWithoutPolicyNumber,
	en_allianzcz_solvdui: enSolvdUiMessages,
	hu_allianzhu_solvdui: assignHU(messages_hu_allianzhu_solvdui),
	hr_allianzhr_solvdui: assignHR(messages_hr_allianzhr_solvdui),
	sk_allianzsk_solvdui: assignSK(messages_sk_allianzsk_solvdui),
	sl_allianzsi_solvdui: assignSL(messages_sl_allianzsi_solvdui),
};

export type DefaultLocaleType = keyof typeof localeMessages;
export const DefaultLocaleNames: string[] = Object.keys(localeMessages);

export const messages = {
	...localeMessages,
	...customersLocaleMessages,
	...customersProcessLocaleMessages,
	...customersSpecialLocaleMessages,
};

function assignPL(messages: Partial<typeof messages_pl>): typeof messages_pl {
	return Object.assign({}, messages_pl, messages);
}

function assignEN(messages: Partial<typeof messages_en>): typeof messages_en {
	return Object.assign({}, messages_en, messages);
}

function assignCS(messages: Partial<typeof messages_cs>): typeof messages_cs {
	return Object.assign({}, messages_cs, messages);
}

function assignDE(messages: Partial<typeof messages_de>): typeof messages_de {
	return Object.assign({}, messages_de, messages);
}

function assignAT(messages: Partial<typeof messages_at>): typeof messages_at {
	return Object.assign({}, messages_at, messages);
}

function assignSK(messages: Partial<typeof messages_sk>): typeof messages_sk {
	return Object.assign({}, messages_sk, messages);
}

function assignSL(messages: Partial<typeof messages_sl>): typeof messages_sl {
	return Object.assign({}, messages_sl, messages);
}

function assignCA(messages: Partial<typeof messages_ca>): typeof messages_ca {
	return Object.assign({}, messages_ca, messages);
}

function assignRU(messages: Partial<typeof messages_ru>): typeof messages_ru {
	return Object.assign({}, messages_ru, messages);
}

function assignES(messages: Partial<typeof messages_es>): typeof messages_es {
	return Object.assign({}, messages_es, messages);
}

function assignPT(messages: Partial<typeof messages_pt>): typeof messages_pt {
	return Object.assign({}, messages_pt, messages);
}

function assignRO(messages: Partial<typeof messages_ro>): typeof messages_ro {
	return Object.assign({}, messages_ro, messages);
}

function assignHR(messages: Partial<typeof messages_hr>): typeof messages_hr {
	return Object.assign({}, messages_hr, messages);
}

function assignHU(messages: Partial<typeof messages_hu>): typeof messages_hu {
	return Object.assign({}, messages_hu, messages);
}
